import { HelpBoxIcon } from './HelpBoxIcon';

/**
 * author: Austin Andrews
 * id 6EFBBE96-37EA-4372-98CC-9B0D84B92C34
 * name help-box
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/help-box.svg
 * tags
 */
export const QuestionMarkBoxIcon = HelpBoxIcon;
export default QuestionMarkBoxIcon